import NetworkSpeed from 'network-speed';
import Env from './Env';

/**
 * InternetSpeedTest. downloads a file from S3 to run a bandwidth speed test.
 */
const fileSize = 512000; // 500 kb
// BandwidthTestFile is located in the aqua-static-assets S3 bucket in the Game Content folder
const testFile = '/BandwidthTestFile';
let lastSpeed; // { bps: "00.00", kbps: "00.00", mbps: "00.00" }

/**
 * Runs speed test. Will download a sample file and store the collected bandwidth in lastSpeed.
 * @returns {Promise<void>} { bps: "00.00", kbps: "00.00", mbps: "00.00" }
 */
const updateSpeed = async () => {
  // Set lastSpeed to empty object so it doesn't get triggered to download twice from different places.
  lastSpeed = {};
  const testNetworkSpeed = new NetworkSpeed();
  const baseUrl = `${Env.GAME_CONTENT_URL}${testFile}`;
  lastSpeed = await testNetworkSpeed.checkDownloadSpeed(baseUrl, fileSize);
  return lastSpeed;
};

/**
 * Will call updateSpeed if lastSpeed is null. Then returns lastSpeed
 * @returns {*} lastSpeed { bps: "00.00", kbps: "00.00", mbps: "00.00" }
 */
const getLastInternetSpeed = () => {
  if (!lastSpeed) {
    updateSpeed();
  }
  return lastSpeed;
};

export default getLastInternetSpeed;
